// Tab configuration for meeting panel
export const TAB_TYPES = {
  SUMMARY: 'summary',
  KEYPOINTS: 'keypoints',
  TRANSCRIPTION: 'transcription'
};

export const TABS_CONFIG = [
  {
    index: 0,
    type: TAB_TYPES.SUMMARY,
    labelKey: 3 // getSentence(3) = "summary"
  },
  {
    index: 1,
    type: TAB_TYPES.KEYPOINTS,
    labelKey: 4 // getSentence(4) = "key points"
  },
  {
    index: 2,
    type: TAB_TYPES.TRANSCRIPTION,
    labelKey: 5 // getSentence(5) = "transcription"
  }
];

// Editor data types
export const EDITOR_DATA_TYPES = {
  SUMMARY: 'summary',
  KEYPOINTS: 'keypoints'
}; 